export default class TripRequestsClient {
    constructor(apiClient) {
        this.tripRequestUri = '/v3/trip_requests';
        this.apiClient = apiClient;
        this.postTripRequest = this.postTripRequest.bind(this);
        this.putTripRequest = this.putTripRequest.bind(this);
        this.putTripRequestAssignment = this.putTripRequestAssignment.bind(this);
        this.putTripRequestMatchingNotes = this.putTripRequestMatchingNotes.bind(this);
        this.putTripRequestStatus = this.putTripRequestStatus.bind(this);
        this.getTripRequests = this.getTripRequests.bind(this);
        this.tripRequestExists = this.tripRequestExists.bind(this);
        this.getTripRequest = this.getTripRequest.bind(this);
        this.postTripRequestTraveler = this.postTripRequestTraveler.bind(this);
        this.deleteTripRequestTraveler = this.deleteTripRequestTraveler.bind(this);
        this.postTripRequestChecklistItems = this.postTripRequestChecklistItems.bind(this);
        this.deleteTripRequestChecklistItems = this.deleteTripRequestChecklistItems.bind(this);
        this.deleteTripRequestChecklistItem = this.deleteTripRequestChecklistItem.bind(this);
        this.postTripRequestFollower = this.postTripRequestFollower.bind(this);
        this.deleteTripRequestFollower = this.deleteTripRequestFollower.bind(this);
        this.getTripRequestVersions = this.getTripRequestVersions.bind(this);
        this.tripRequestVersionExists = this.tripRequestVersionExists.bind(this);
        this.getTripRequestVersion = this.getTripRequestVersion.bind(this);
        this.postTripRequestScores = this.postTripRequestScores.bind(this);
        this.postTripRequestTripMatches = this.postTripRequestTripMatches.bind(this);
        this.getTripRequestTripMatches = this.getTripRequestTripMatches.bind(this);
        this.postTripMatchSuggestions = this.postTripMatchSuggestions.bind(this);
        this.getConversationSummaries = this.getConversationSummaries.bind(this);
        this.getTripRequestSearches = this.getTripRequestSearches.bind(this);
        this.postTripRequestSearches = this.postTripRequestSearches.bind(this);
        this.putTripRequestVisibilityFlags = this.putTripRequestVisibilityFlags.bind(this);
    }
    postTripRequest(data, config) {
        return this.apiClient.post(this.tripRequestUri, data, config);
    }
    putTripRequest(id, data, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}`, data, config);
    }
    putTripRequestAssignment(id, data, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}/assigned_to`, data, config);
    }
    putTripRequestMatchingNotes(id, data, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}/matching_notes`, data, config);
    }
    putTripRequestStatus(id, data, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}/status`, data, config);
    }
    putTripRequestVerifications(id, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}/verifications`, config);
    }
    getTripRequests(config) {
        return this.apiClient.get(this.tripRequestUri, config);
    }
    tripRequestExists(id, config) {
        return this.apiClient.exists(`${this.tripRequestUri}/${id}`, config);
    }
    getTripRequest(id, config) {
        return this.apiClient.get(`${this.tripRequestUri}/${id}`, config);
    }
    postTripRequestTraveler(id, data, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/travelers`, data, config);
    }
    deleteTripRequestTraveler(id, travelerId, config) {
        return this.apiClient.delete(`${this.tripRequestUri}/${id}/travelers/${travelerId}`, config);
    }
    postTripRequestChecklistItems(id, data, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/checklist_items`, data, config);
    }
    // Delete all items in the Checklist for a Trip Request. config should contain an "item" query param that is
    // a Checklist (array of checklist items)
    deleteTripRequestChecklistItems(id, config) {
        return this.apiClient.delete(`${this.tripRequestUri}/${id}/checklist_items`, config);
    }
    deleteTripRequestChecklistItem(id, item, config) {
        return this.apiClient.delete(`${this.tripRequestUri}/${id}/checklist_items/${item}`, config);
    }
    postTripRequestFollower(id, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/follow`, config);
    }
    deleteTripRequestFollower(id, config) {
        return this.apiClient.delete(`${this.tripRequestUri}/${id}/follow`, config);
    }
    getTripRequestVersions(id, config) {
        return this.apiClient.get(`${this.tripRequestUri}/${id}/versions`, config);
    }
    tripRequestVersionExists(id, updateId, config) {
        return this.apiClient.exists(`${this.tripRequestUri}/${id}/versions/${updateId}`, config);
    }
    getTripRequestVersion(id, updateId, config) {
        return this.apiClient.get(`${this.tripRequestUri}/${id}/versions/${updateId}`, config);
    }
    postTripRequestScores(id, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/scores`, config);
    }
    postTripRequestTripMatches(id, data, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/trip_matches`, data, config);
    }
    getTripRequestTripMatches(id, config) {
        return this.apiClient.get(`${this.tripRequestUri}/${id}/trip_matches`, config);
    }
    // Pass an array of country codes to get match suggestions for those countries
    postTripMatchSuggestions(id, data, config) {
        return this.apiClient.post(`${this.tripRequestUri}/${id}/trip_match_suggestions`, data, config);
    }
    getConversationSummaries(id, config) {
        return this.apiClient.get(`${this.tripRequestUri}/${id}/conversation_summaries`, config);
    }
    getTripRequestSearches(config) {
        return this.apiClient.get('/v3/trip_request_searches', config);
    }
    postTripRequestSearches(data, config) {
        return this.apiClient.post('/v3/trip_request_searches', data, config);
    }
    putTripRequestVisibilityFlags(id, data, config) {
        return this.apiClient.put(`${this.tripRequestUri}/${id}/visibilities`, data, config);
    }
}
